import { assign, isMap } from "@/core/utils";
var Store = /** @class */ (function () {
    function Store(parameters) {
        this._listeners = {};
        var store = this;
        var dispatch = store.dispatch, commit = store.commit;
        this._state = assign(Object.create(null), parameters.state);
        this._mutations = assign(Object.create(null), parameters.mutations);
        this._actions = assign(Object.create(null), parameters.actions);
        this.doStateReactively(this._state);
        // bind
        this.dispatch = function (type, payload) { return dispatch.call(store, type, payload); };
        this.commit = function (type, payload) { return commit.call(store, type, payload); };
    }
    /**
     * ミューテーションを実行
     * @param type
     * @param payload
     */
    Store.prototype.commit = function (type, payload) {
        var mutation = this._mutations[type];
        if (!mutation) {
            console.error("[store] unknown mutation type: " + type);
            return;
        }
        mutation(this._state, payload);
    };
    /**
     * アクションを実行
     * @param type
     * @param payload
     */
    Store.prototype.dispatch = function (type, payload) {
        var action = this._actions[type];
        if (!action) {
            console.error("[store] unknown action type: " + type);
            return;
        }
        return action(this, payload);
    };
    /**
     * リスナーを登録
     * @param type
     * @param listener
     */
    Store.prototype.watch = function (type, listener) {
        var _this = this;
        if (!this._listeners[type]) {
            this._listeners[type] = [];
        }
        this._listeners[type].push(listener);
        return function () {
            setTimeout(function () { return _this._listeners[type].splice(_this._listeners[type].indexOf(listener), 1); }, 1);
        };
    };
    /**
     * 状態をリアクティブ化する
     * @param state
     * @param prefix
     */
    Store.prototype.doStateReactively = function (state, prefix) {
        if (!isMap(state)) {
            return;
        }
        for (var type in state) {
            if (Object.prototype.hasOwnProperty.call(state, type)) {
                var _state = state[type];
                var _type = prefix ? prefix + "." + type : type;
                this.doStateReactively(_state, _type);
                Object.defineProperty(state, type, this.createReactiveObject(this, _state, _type));
            }
        }
    };
    /**
     * リアクティブオブジェクトを作成
     * @param self
     * @param value
     * @param key
     */
    Store.prototype.createReactiveObject = function (self, value, key) {
        var _value = value;
        return {
            get: function () {
                return _value;
            },
            set: function (value) {
                if (_value === value) {
                    return;
                }
                _value = value;
                self.doStateReactively(_value, key);
                if (!self._listeners[key]) {
                    return;
                }
                for (var _i = 0, _a = self._listeners[key]; _i < _a.length; _i++) {
                    var observer = _a[_i];
                    observer(self._state);
                }
            },
        };
    };
    Object.defineProperty(Store.prototype, "state", {
        /**
         * 状態を取得
         */
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    return Store;
}());
export default Store;
